import { initializeApp } from "firebase/app";
import firebase from 'firebase/compat/app';
import { getAuth } from "firebase/auth";
// May be this compat useful in future
import 'firebase/compat/storage';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCO_gJ5cDCtddxLQrYBTTt-h0wQWS5OIIg",
  authDomain: "pixala-clikd.firebaseapp.com",
  projectId: "pixala-clikd",
  databaseURL:"https://pixala-clikd-default-rtdb.firebaseio.com/",
  storageBucket: "pixala-clikd.appspot.com",
  messagingSenderId: "718329128937",
  appId: "1:718329128937:web:00e20a58dcee6179ba0d78",
  measurementId: "G-NVETS4EPFM",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export const auth = getAuth(app);
export { projectStorage, projectFirestore, timestamp };